import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getCadOptions } from '@/app/assets/actions/importOptions';

export const useCADOptionsQuery = (
  options?: Omit<UseQueryOptions<Awaited<ReturnType<typeof getCadOptions>>>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    ...options,
    staleTime: Infinity,
    queryKey: ['CAD settings'],
    queryFn: async () => await getCadOptions(),
    placeholderData: (prev) => prev,
    structuralSharing: false,
    throwOnError: false,
  });
};
